export default __webpack_public_path__ + "static/media/Bracers of Black Whispers.afdf8b95.jpg";